"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettlementsPartnersDownloadValidation = exports.getSettlementsMonthlyValidation = exports.getSettlementsDownloadValidation = exports.getSettlementsValidation = exports.getHolidaysYearValidation = void 0;
var utils_1 = require("./utils");
function getHolidaysYearValidation(request) {
    var errorList = [];
    var pathParams = request.pathParams;
    if (!pathParams.year) {
        utils_1.addErrorList(errorList, 'year', 'GET_HOLIDAYS_YEAR_YEAR');
    }
    return errorList;
}
exports.getHolidaysYearValidation = getHolidaysYearValidation;
function getSettlementsValidation(request) {
    var errorList = [];
    var params = request.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_SETTLEMENTS_MALL_NO');
    }
    if (!params.year) {
        utils_1.addErrorList(errorList, 'year', 'GET_SETTLEMENTS_YEAR');
    }
    if (!params.month) {
        utils_1.addErrorList(errorList, 'month', 'GET_SETTLEMENTS_MONTH');
    }
    if (!params.page) {
        utils_1.addErrorList(errorList, 'page', 'GET_SETTLEMENTS_PAGE');
    }
    if (!params.size) {
        utils_1.addErrorList(errorList, 'size', 'GET_SETTLEMENTS_PAGE_SIZE');
    }
    return errorList;
}
exports.getSettlementsValidation = getSettlementsValidation;
function getSettlementsDownloadValidation(request) {
    var errorList = [];
    var params = request.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_SETTLEMENTS_DOWNLOAD_MALL_NO');
    }
    if (!params.year) {
        utils_1.addErrorList(errorList, 'year', 'GET_SETTLEMENTS_DOWNLOAD_YEAR');
    }
    if (!params.month) {
        utils_1.addErrorList(errorList, 'month', 'GET_SETTLEMENTS_DOWNLOAD_MONTH');
    }
    return errorList;
}
exports.getSettlementsDownloadValidation = getSettlementsDownloadValidation;
function getSettlementsMonthlyValidation(request) {
    var errorList = [];
    var params = request.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_SETTLEMENTS_MONTHLY_MALL_NO');
    }
    if (!params.year) {
        utils_1.addErrorList(errorList, 'year', 'GET_SETTLEMENTS_MONTHLY_YEAR');
    }
    if (!params.month) {
        utils_1.addErrorList(errorList, 'month', 'GET_SETTLEMENTS_MONTHLY_MONTH');
    }
    return errorList;
}
exports.getSettlementsMonthlyValidation = getSettlementsMonthlyValidation;
function getSettlementsPartnersDownloadValidation(request) {
    var errorList = [];
    var params = request.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_SETTLEMENTS_PARTNERS_DOWNLOAD_MALL_NO');
    }
    if (!params.year) {
        utils_1.addErrorList(errorList, 'year', 'GET_SETTLEMENTS_PARTNERS_DOWNLOAD_YEAR');
    }
    if (!params.month) {
        utils_1.addErrorList(errorList, 'month', 'GET_SETTLEMENTS_PARTNERS_DOWNLOAD_MONTH');
    }
    return errorList;
}
exports.getSettlementsPartnersDownloadValidation = getSettlementsPartnersDownloadValidation;
